"use client";

import { Select } from "@costar-ui/components";
import { useState } from "react";

export interface IUpsellFormDropdown {
  value: string;
  onChangeHandler: (value: string) => void;
  messages: {
    industry: string;
    lender: string;
    multifamilyPropertyManager: string;
    broker: string;
    retailer: string;
    serviceProvider: string;
    ownerAndDeveloper: string;
    appraiser: string;
  };
}

export const UpsellFormDropdown = (props: IUpsellFormDropdown) => {
  const { onChangeHandler, messages } = props;
  const industryOptions = [
    {
      id: 1,
      label: messages.lender,
    },
    {
      id: 2,
      label: messages.multifamilyPropertyManager,
    },
    {
      id: 3,
      label: messages.broker,
    },
    {
      id: 4,
      label: messages.retailer,
    },
    {
      id: 5,
      label: messages.serviceProvider,
    },
    {
      id: 6,
      label: messages.ownerAndDeveloper,
    },
    {
      id: 7,
      label: messages.appraiser,
    },
  ];

  return (
    <Select
      automation-id="upsell-message-form-dropdown"
      items={industryOptions}
      placeholder={messages.industry}
      onChange={(e) => {
        onChangeHandler(e?.label || industryOptions[0].label);
      }}
    ></Select>
  );
};
